import React from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import PagesNav from "./PagesNav";

const LegacyFinanceNotice = () => {
  const location = useLocation();
  const legacyPath = location.pathname.startsWith("/finance")
    ? location.pathname
    : "/finance";
  const navItems = [
    {
      name: "بيانات قديمة",
      to: legacyPath
    },
    {
      name: "طلبات التقسيط",
      to: "/installment-operations"
    }
  ];

  return (
    <section dir="rtl">
      <div className="d-flex gap-3 mb-3 align-items-center">
        <PagesNav links={navItems} />
      </div>

      <Card className="shadow-sm border-0">
        <Card.Body className="p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-3">
            <div>
              <h1 className="text-main fw-bold fs-3 mb-2">
                صفحة قديمة للرجوع فقط
              </h1>
              <p className="text-muted mb-0">
                تم نقل إدارة طلبات التقسيط إلى صفحة طلبات التقسيط.
              </p>
            </div>
            <Button
              as={Link}
              to="/installment-operations"
              variant="outline-primary"
              className="fw-bold"
            >
              فتح طلبات التقسيط
            </Button>
          </div>

          <Alert variant="warning" className="mb-3">
            هذه الصفحة مخصصة للرجوع إلى بيانات قديمة فقط، ولا تستخدم لإدارة
            العمليات المتوافقة.
          </Alert>

          <Alert variant="info" className="mb-0">
            معلومات رسوم المنصة وحالة العقد والتفعيل تتم إدارتها من صفحة
            طلبات التقسيط.
          </Alert>
        </Card.Body>
      </Card>
    </section>
  );
};

export default LegacyFinanceNotice;
